import { render, staticRenderFns } from "./TeamStats.vue?vue&type=template&id=507e0fde&scoped=true&"
import script from "./TeamStats.vue?vue&type=script&lang=js&"
export * from "./TeamStats.vue?vue&type=script&lang=js&"
import style0 from "./TeamStats.vue?vue&type=style&index=0&id=507e0fde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507e0fde",
  null
  
)

export default component.exports